import { initializerDefineProperty as _initializerDefineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";
import { applyDecoratedDescriptor as _applyDecoratedDescriptor } from "\0rollupPluginModLoBabelHelpers.js";
import { initializerWarningHelper as _initializerWarningHelper } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _dec2, _class, _class2, _descriptor, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "aa7f1p+DHNM8ZaxtGIGWx6g", "RewriteButton", undefined);

//@ts-nocheck
import { _decorator, Component, Button, EventHandler as ComponentEventHandler, SystemEventType, Director, Font, Label, Line } from 'cc';
import { App } from './manager/App';
import { E_SoundType } from './manager/SoundManager';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var RewriteButton = (_dec = ccclass('RewriteButton'), _dec2 = property(Font), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RewriteButton, _Component);

  function RewriteButton() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _initializerDefineProperty(_assertThisInitialized(_this), "ft", _descriptor, _assertThisInitialized(_this));

    return _this;
  }

  var _proto = RewriteButton.prototype;

  _proto.onLoad = function onLoad() {
    this.reWriteOnTouchEnd();
    this.overwriteDT(); // this.resetFont();

    this.resetLineComponent();
  };

  _proto.resetLineComponent = function resetLineComponent() {
    return;

    Line.prototype.onLoad = function onLoad() {
      var model = this._model = legacyCC.director.root.createModel(LineModel);
      model.node = model.transform = this.node;

      if (this._material === null) {
        this._material = new Material();

        this._material.copy(builtinResMgr.get('default-trail-material'));

        define[CC_USE_WORLD_SPACE] = this.worldSpace;
        _matInsInfo.parent = this._material;
        _matInsInfo.subModelIdx = 0;
        this._materialInstance = new MaterialInstance(_matInsInfo);

        this._materialInstance.recompileShaders(define);
      }

      model.updateMaterial(this._materialInstance);
      model.setCapacity(150);
    };
  };

  _proto.resetFont = function resetFont() {
    // if delete the font, we should change isSystemFontUsed to true
    var font = this.ft;

    Label.prototype.onEnable = function onEnable() {
      // super.onEnable();
      this.node.on(SystemEventType.ANCHOR_CHANGED, this._nodeStateChange, this);
      this.node.on(SystemEventType.SIZE_CHANGED, this._nodeStateChange, this);
      this.updateMaterial();
      this._renderFlag = this._canRender();
      this._font = font;
      this._isSystemFontUsed = false; // TODO: Hack for barbarians

      if (!this._font && !this._isSystemFontUsed) {
        this.useSystemFont = true;
      } // Reapply default font family if necessary


      if (this._isSystemFontUsed && !this._fontFamily) {
        this.fontFamily = 'Arial';
      }

      this.updateRenderData(true);
    };
  };

  _proto.reWriteOnTouchEnd = function reWriteOnTouchEnd() {
    Button.prototype["_onTouchEnded"] = function _onTouchEnded(event) {
      var _this2 = this;

      var ispass = false;

      if (!this.interactable || !this.enabledInHierarchy || event.target["isClick"] || App.GameCtrl.isSwitch) {
        ispass = true;
      }

      var that = this;
      var deltaTime = 200;

      if (!ispass) {
        // cc.log("..event.target.name ...", event.target.name);
        event.target["isClick"] = true;

        if (this._pressed) {
          var checkArr = [];

          if (checkArr.indexOf(event.target.name) != -1) {
            ComponentEventHandler.emitEvents(that.clickEvents, event);
            this.node.emit(Button.EventType.CLICK, that);
            event.target["isClick"] = false;
          } else {
            var soundArr = [];

            if (soundArr.indexOf(event === null || event === void 0 ? void 0 : event.target.name) != -1) {
              App.SoundMgr.playEffectType(E_SoundType.OpenLayer);
            } else {
              App.SoundMgr.playEffectType(E_SoundType.Click);
            }

            setTimeout(function () {
              if (that.clickEvents && event) {
                ComponentEventHandler.emitEvents(that.clickEvents, event);
              }

              if (that.node) {
                _this2.node.emit(Button.EventType.CLICK, that);
              }

              if (event) {
                event.target["isClick"] = false;
              }
            }, deltaTime);
          }
        }
      } else {
        setTimeout(function () {
          if (event) {
            event.target["isClick"] = false;
          }
        }, deltaTime); // return;
      }

      this._pressed = false;

      this._updateState();

      if (event) {
        event.propagationStopped = true;
      }
    };
  };

  _proto.overwriteDT = function overwriteDT() {
    window["kSpeed"] = 1;
    var _originCalculateDeltaTime = Director.prototype.calculateDeltaTime;

    Director.prototype.calculateDeltaTime = function (now) {
      _originCalculateDeltaTime.call(this, now);

      this._deltaTime *= window["kSpeed"];
    };
  } // update (deltaTime: number) {
  //     // [4]
  // }
  ;

  return RewriteButton;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "ft", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
})), _class2)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();